import { isBefore, parseISO, startOfDay } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { toCalendarDay } from '@utils/timeZone';
import { GetSeriesCalendarModifiersParams, SeriesCalendarModifiers } from './types';

export const getSeriesCalendarModifiers = ({
  relatedMultischedules,
  currentScheduleId,
  addedDates,
  zone,
}: GetSeriesCalendarModifiersParams): SeriesCalendarModifiers => {
  const today = startOfDay(toZonedTime(new Date(), zone));
  const modifiers: SeriesCalendarModifiers = {
    scheduled: [],
    draft: [],
    overdue: [],
    completed: [],
    added: addedDates.map(toCalendarDay),
  };
  Object.values(relatedMultischedules || {})
    .flat()
    .filter((el) => el.id !== currentScheduleId)
    .forEach((el) => {
      const day = startOfDay(toZonedTime(parseISO(el.startsAt), zone));
      const status = el.completed
        ? 'completed'
        : isBefore(day, today)
          ? 'overdue'
          : el.draft
            ? 'draft'
            : 'scheduled';
      modifiers[status].push(day);
    });
  return modifiers;
};

export const hasSeriesCalendarDays = (modifiers: SeriesCalendarModifiers) =>
  Object.values(modifiers).some((days) => days.length > 0);
